import { Alert, Button, Row, Space, Typography } from "antd"
import VSpace from "../common/VSpace"
import { faCheck, faXmark } from "@fortawesome/pro-solid-svg-icons"
import { grey } from "@ant-design/colors"
import IconAndTextButton from "../IconAndTextButton"

type Props = {
  isChecked: boolean
  onChange: (isChecked: boolean) => void
  description: string
  goToLink: string
  goToText: string
  helpLink: string
}

const StepContent = ({isChecked, description, goToLink, goToText, helpLink, onChange}: Props) => {
  return <VSpace style={{paddingLeft: '32px'}} size="large">
    {isChecked && <Alert message="Nice job! You've marked this step complete" type="success" showIcon />}
    <VSpace>
      <Row>{description}</Row>
      <Row justify="end">
        <Space>
          {goToLink.length > 0 && <Button href={goToLink}>{goToText}</Button>}
          {helpLink.length > 0 && <Button href={helpLink} target="_blank">Show Me How</Button>}
        </Space>
      </Row>
    </VSpace>
    <Row justify="end">
      <IconAndTextButton
        onClick={() => onChange(!isChecked)}
        type={isChecked ? undefined : 'primary'}
        icon={isChecked ? faXmark : faCheck}
        text={isChecked ? "Mark Incomplete" : "Mark Complete"}
      />
    </Row>
    <Row justify="end" style={{marginTop: '20px', color: grey[3], fontSize: '12px'}}>
      Stuck on this step? Ping us in the chat, or&nbsp;
      <Typography.Link style={{fontSize: '12px'}} href="https://synkedup.com/book-a-support-call/" target="_blank">
        get on a Zoom call with us here
      </Typography.Link>
    </Row>
  </VSpace>
}

export default StepContent